import { colors, fontSizes } from "@/app/constants/styles";
import { StyleSheet, TextStyle, ViewStyle } from "react-native";

type OptionsStyles = {
  container: ViewStyle;
  listContainer: ViewStyle;
  optionText: TextStyle;
};

export const getOptionsStyles = (
  isBasketItemSelected: boolean,
): OptionsStyles =>
  StyleSheet.create({
    container: {
      flex: 3,
      flexDirection: "row",
    },
    listContainer: {
      flex: 15,
      flexDirection: "column",
    },
    optionText: {
      fontFamily: "HelveticaNeue",
      paddingBottom: 10,
      fontSize: fontSizes.x10,
      color: isBasketItemSelected ? colors.white : colors.cedar,
    },
  });
